module.exports = __webpack_public_path__ + "static/media/Twitter_Social_Icon_Rounded_Square_Color.c2f1acf6.svg";